export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}

export interface SortOptions {
  [column: string]: SortOrder;
}

interface QueryType {
  type: string;
  body: string;
}

export interface QueryOptions {
    readonly full_text_search?: string;
    readonly order_by?: SortOptions[];
    readonly results_per_page?: number;
    readonly page_number?: number;
    readonly $query?: QueryType;
}
